import { forwardRef } from 'react';

import { styled } from '@spazious/dollhouse-theme';
import { Flex, FlexElement, FlexProps } from '@spazious/dollhouse-uikit';

export type FloatingElement = FlexElement;
export interface FloatingProps extends FlexProps {
  children?: React.ReactNode;
}

export const FloatingPanel = styled(
  forwardRef<FloatingElement, FlexProps>(({ children, ...restProps }: FloatingProps) => {
    return <Flex {...restProps}>{children}</Flex>;
  })
)`
  // position: fixed;
  user-select: none;
  right: 16px;
  // top: 16px;
  // bottom: 16px;
  border-radius: 8px;
  backdrop-filter: var(--spz-sys-filter-panel);
  background-color: var(--spz-sys-color-panel);
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.2);
`;
